import request from '../request';

/**
 * Запрашивает мероприятия в афише
 * @param {Object} [params]
 * @param {('combined' | 'service_tagless' | 'match' | 'performance' | 'subscription')} params.blocking
 * @param {Object} params.pagination
 * @param {number} params.pagination.page
 * @param {number} [params.pagination.limit]
 * @param {Object<string, any>} params.params
 * @return {Promise<{ items: import("../types/site").PosterItem[], leftCount: number }>}
 */
export const getPosterItems = (params) => request({
  url: '/poster',
  type: 'POST',
  addCSRFToken: true,
  data: params || {},
  needOverlay: false,
});

export const getCalendarPosterItems = (params = {}) => request({
  url: '/poster/get-calendar-data',
  type: 'GET',
  addCSRFToken: true,
  data: params,
  needOverlay: false,
});
